
import XDialog from 'vux/src/components/x-dialog/index.vue'

import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
export default {
name: 'bindLogin',
data () {
return {
username: '',
password: '',
openId: '',
envType: 'test',
show: false
}
},
components: {
XDialog
},
methods: {
onCopy () {
this.$vux.toast.text('已复制')
},
onError (error) {
console.log(error)
},
onRefresh () {
window.location.replace(window.location.protocol + '//' + window.location.host + '/v2/api/index')
},
isAuth () {
this.$http({
method: 'post',
url: '/workorder/ordertype/menu'
}).then(res => {
if (res.result.length > 1) {
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}





} else {
this.$http({
method: 'post',
url: '/report/isauth'
}).then(res => {
if (res.result) {
let roleType = this.getCookie('roleType') || ''
if (+roleType === 1) {
this.$router.push({ path: '/schoollist', query: { type: 1 } })
} else {
this.$router.push({ path: '/dataCenter' })
}
} else {
this.$router.push({ path: '/noauth' })
}
}).catch(error => {
console.log(error)
})
}
}).catch(error => {
console.log(error)
})
},
login () {
if (this.username === '') {
this.$vux.toast.text('请输入您的用户名')
} else if (this.password === '') {
this.$vux.toast.text('请输入您的密码')
} else {









var params = new URLSearchParams()
params.append('username', this.username)
params.append('password', this.password)
this.$http({
method: 'post',
url: '/login',
data: params
}).then(res => {
if (+res.code === 100) {
if (res.result != null && res.result.needEditPwd != null && res.result.needEditPwd) {
this.show = true
} else if (res.result === 'user_bind_other') {
this.$vux.toast.text('当前微信已经绑定其它账号')
} else {
this.isAuth()
}
} else {
this.$vux.toast.text(res.msg || res.result.msg || res.result)
}
}).catch(error => {
console.log(error)
})
}
},
blurAdjust (e) {
var u = navigator.userAgent
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
if (isIOS) {
setTimeout(() => {
if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
return
}
let result = 'pc'
if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断iPhone|iPad|iPod|iOS
result = 'ios'
} else if (/(Android)/i.test(navigator.userAgent)) { // 判断Android
result = 'android'
}
if (result === 'ios') {
document.activeElement.scrollIntoViewIfNeeded(true)
}
}, 100)
}
}
}
}




// WEBPACK FOOTER //
// ./src/components/bindLogin/bindLogin.vue